import { Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { ColumnDataType } from "@app/main/components/reports/enums/ColumnDataType";
import { IColumnHeader } from "@app/main/components/reports/models/IColumnHeader";
import { DateService } from "@app/services/date.service";
import copy from "fast-copy";
import { DynamicReportService, IReportCategory } from "../../_services/dynamicReports.service";
import './table-column-selector.component.scss';

@Component({
    selector: 'v-table-column-selector',
    template: require('./table-column-selector.component.html')
})
export class VTableColumnSelectorComponent {
    @Input() allColumns: IColumnHeader[] = [];
    @Input() selectedColumns: IColumnHeader[];
    @Input() maxColumns: number;

    @Output() columnsChanged = new EventEmitter<IColumnHeader[]>();

    //--

    showColumnPicker: boolean;
    columnsHaveChanged: boolean;

    columnToEdit: IColumnHeader;
    columnPickerLoading: boolean;

    reportCategories: IReportCategory[];
    displayReportCategories: IReportCategory[];

    showFilterValueOperators: boolean;
    showAddColumnDialog: boolean;
    canFilterColumn: boolean;
    showTimeFilter: boolean;

    categoryFilterTitle = "All";
    constructor(
        private readonly dateService: DateService,
        private readonly reportService: DynamicReportService) { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.allColumns) {
            this.reportService.getDisplayColumnHeaders().then(headers => {
                this.allColumns = headers;

            });

            return;
        }

        if (this.selectedColumns) {
            this.selectedColumns = copy(this.selectedColumns);
        }
    }

    ngOnDestroy(): void {
        if (this.showColumnPicker && this.columnsHaveChanged) {
            this.columnsChanged.emit(this.selectedColumns);
        }
    }

    onSearch(searchString: string) {
        if (!searchString) {
            this.displayReportCategories = this.reportCategories;
            return;
        }

        const searchStringLower = searchString.toLocaleLowerCase();
        this.displayReportCategories = [];

        // Now search
        this.reportCategories.forEach(c => {
            const matchingReportColumns = c.columns.filter(c => c.Title.toLocaleLowerCase().indexOf(searchStringLower) >= 0);

            if (!matchingReportColumns.length) {
                return;
            }

            this.displayReportCategories.push({
                title: c.title,
                icon: c.icon,
                columns: matchingReportColumns
            });
        })
    }

    categoryFilterChanged() {

        if (this.categoryFilterTitle == "All") {
            this.displayReportCategories = this.reportCategories;
            return;
        }

        this.displayReportCategories = [];
        this.reportCategories.forEach(c => {
            if (c.title == this.categoryFilterTitle) {
                this.displayReportCategories.push(c);
            }
        });
    }

    editColumn(column: IColumnHeader) {
        if (this.columnToEdit === column) {
            this.columnToEdit = null;
            this.setColumnFilterOptions();
            return;
        }

        this.columnToEdit = column;
        this.setColumnFilterOptions();

        if (!column) {
            this.selectedColumnChanged();
        }
    }

    setColumnFilterOptions() {
        this.showTimeFilter = false;
        this.canFilterColumn = false;
        this.showFilterValueOperators = false;

        if (this.columnToEdit == null) {
            return;
        }

        if (this.columnToEdit.ColumnDefinition.Type === ColumnDataType.Duration) {
            this.showTimeFilter = true;
            const timeFilter = this.dateService.getTimeAsString(this.columnToEdit.FilterValue);
        }

        if (this.columnToEdit.ColumnDefinition.Type === ColumnDataType.Double ||
            this.columnToEdit.ColumnDefinition.Type === ColumnDataType.Int ||
            this.columnToEdit.ColumnDefinition.Type === ColumnDataType.Score ||
            this.columnToEdit.ColumnDefinition.Type === ColumnDataType.Percent ||
            this.columnToEdit.ColumnDefinition.Type === ColumnDataType.Duration) {
            this.canFilterColumn = true;
            this.canFilterColumn = true;
            this.showFilterValueOperators = true;

            if (!isNaN(Number(this.columnToEdit.FilterValue))) {
                this.columnToEdit.FilterValue = +this.columnToEdit.FilterValue;
            }

        }

        if (this.columnToEdit.ColumnDefinition.Type === ColumnDataType.String ||
            this.columnToEdit.ColumnDefinition.Type === ColumnDataType.List ||
            this.columnToEdit.ColumnDefinition.Type === ColumnDataType.Location) {
            this.canFilterColumn = true;
            this.showFilterValueOperators = false;
        }
    }

    selectedColumnChanged() {
        this.updateSelectedDisplayColumns();
        this.columnsHaveChanged = true;

        this.columnsChanged.emit(this.selectedColumns);
    }

    showColumnPickerDialog() {
        this.showColumnPicker = true;

        // We reset this so subsequent dialog loads are also fast to transition
        this.reportCategories = [];
        this.displayReportCategories = [];

        // Creating the columns is expensive, so we delay by 300ms to allow any animations to finish first
        this.columnPickerLoading = true;
        setTimeout(() => {

            this.reportCategories = this.reportService.getUniqueReportCategories(this.allColumns);
            this.displayReportCategories = this.reportCategories;

            this.columnPickerLoading = false;
        }, 300);
    }

    hideColumnPickerDialog() {
        this.showColumnPicker = false;

        this.resetCategoryFilterTitle();
        this.selectedColumnChanged();
    }
    //--

    private updateSelectedDisplayColumns() {
        if (!this.reportCategories) {
            return;
        }

        this.reportCategories.forEach(cat => {
            cat.columns.forEach(col => {
                (col as any).selected = this.selectedColumns.find(c => c.Title == col.Title) != null;
            });
        });
    }

    private resetCategoryFilterTitle(): void {
        this.categoryFilterTitle = "All";
    }

}
